/* @ngInject */
const saleIcons = () => {
  const self = {}

  self.number = 'build'
  self.date = 'today'
  self.train = 'train'

  return self
}
export default saleIcons



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/scrapping/sale/resources/icons.resource.js